/*
 * @Author: qinqianwen
 * @Date: 2020-08-06 16:46:10
 * @LastEditTime: 2020-10-12 17:53:07
 * @LastEditors: Please set LastEditors
 * @Description: 用户管理模块api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\userManage.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//获取用户管理表格数据
export function getUserList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/page`,
    method: "post",
    data
  });
}
//新增用户
export function saveAdd(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/save`,
    method: "post",
    data
  });
}
//根据id获取详情
export function getDetailById(id) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getUserById?id=${id}`,
    method: "get"
  });
}
//保存修改
export function saveUpdate(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/update`,
    method: "post",
    data
  });
}
//删除与批量删除
export function batchDelete(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/batchDeleteUser`,
    method: "post",
    data
  });
}
//停用、启用用户
export function setUserEnable(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/enableUser`,
    method: "post",
    data
  });
}
//(下拉框)查询所属客户信息
export function findAllCorpByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCustomerByPage`,
    method: "post",
    data
  });
}
//用户名唯一性校验
export function checkUserName(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/checkUserNameIsExist`,
    method: "get",
    params
  });
}
//登录名唯一性校验
export function checkUserCode(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/checkUserCodeIsExist`,
    method: "get",
    params
  });
}
//保存修改密码
export function updatePassword(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/modifySubUserPassWord`,
    method: "post",
    data
  });
}
//导出用户信息
export function exportUserInfo(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/export`,
    method: "post",
    data
  });
}
//用户下拉树
export function fetchUserTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/user/getUserTree`,
    method: "get"
  });
}
//获取用户更改记录
export function fetchUserUpdateRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/userHistory/page`,
    method: "post",
    data
  });
}
